import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const MessageBoard = createApi({
    reducerPath: "message-board",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["MessageBoard"],
    endpoints: (builder) => ({
        getConversation: builder.query({
            query: () => "conversation/list",
            providesTags: ["MessageBoard"]
        }),
        getSingleConversation: builder.query({
            query: ({ id, pageno,url:singleConversationURL,contractorId }) => {
                let url = `${singleConversationURL}/${id}`;

                if (pageno) {
                    url += `?pageno=${pageno}`
                }
                if(contractorId){
                    url += `&contractorId=${contractorId}`
                }

                return { url, method: "GET" }
            },
            providesTags: ["MessageBoard"]
        }),
        sendMessage: builder.mutation({
            query: (data ) => ({
                url: `/conversation/message`,
                method: "POST",
                body: data
            }),
            // invalidatesTags: ['MessageBoard']
        }),
        markConversationUnread: builder.mutation({
            query: (id) => ({
                url: `conversation/${id}/unread`,
                method: "PATCH",
            }),
        })
    })
});

export const { useGetConversationQuery, useGetSingleConversationQuery, useSendMessageMutation, useMarkConversationUnreadMutation } = MessageBoard